// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__ZYX9S","description":"PatientConsentPreview_description__21TWQ"};